<script>
  import { onMount, getContext } from 'svelte';
  import { fade, fly } from 'svelte/transition';

  import { SEARCH_SPONSORS } from '../../graphql/sponsors';

  const client = getContext('apollo');

  import Loader from '../../components/ui/loader.html';

  export let label;
  export let value;
  export let readonly = false;

  const options = [
    { id: 1, name: 1 },
    { id: 2, name: 2 },
    { id: 3, name: 3 },
    { id: 4, name: 4 },
    { id: 5, name: 5 },
    { id: 6, name: 6 },
    { id: 7, name: 7 },
    { id: 8, name: 8 },
    { id: 9, name: 9 },
    { id: 10, name: 10 },
    { id: 11, name: 11 },
    { id: 12, name: 12 },
    { id: 13, name: 13 }
  ];
</script>

<div>
  {#if label}<label>{label}</label>{/if}
  <select
    disabled="{readonly}"
    readonly="{readonly}"
    class:placeholder="{!value}"
    bind:value
  >
    <option value="{null}">Choose a minumum age</option>
    {#each options as option, i}
    <option value="{option.id}">
      {option.name}
    </option>
    {/each}
  </select>
</div>
